(function () {
    'use strict';
    angular.module('SMART2').directive('smartUiGrid', ['$timeout', '$filter', 'gridConfigProvider', 'APPCONSTANTS', 'httpService', 'uiGridConstants', '$injector',
    function ($timeout, $filter, gridConfigProvider, APPCONSTANTS, httpService, uiGridConstants, $injector) {
        return {
            restrict: 'AE',
            scope: {
                colDef: '@',
                model: '=',
                callback: '&',
                focusRowCol: '@',
                validationService: '@',
                searchTerm: '@',
                otherGridOptions: '@',
                api: '=',
                onRenderingStart: '&',
                onRenderingFinish: '&',
                dynamicPaginationPageSizes: '=',
                dynamicItemTotal: '='

            },
            link: function (scope, element, attr) {
                scope.direction = !!window.isRTL ? "rtl" : "ltr";
                var paginationOptions = {
                    pageNumber: 1,
                    pageSize: 12,
                    sort: null
                };

                if (scope.validationService != undefined) {
                    var service = $injector.get(scope.validationService);
                    scope.$parent[scope.validationService] = service;
                    scope.cellClassFunction = scope.validationService + ".validateGridRow";
                    scope.cellEditableConditionFunction = scope.validationService + ".isEditableGridRow";
                }
                var gridInstance;
                var defaultGridOptions = {
                    paginationPageSizes: scope.dynamicPaginationPageSizes ? scope.dynamicPaginationPageSizes : [10, 25, 50, 75],
                    paginationPageSize: scope.dynamicPaginationPageSizes && scope.dynamicPaginationPageSizes[0] ? scope.dynamicPaginationPageSizes[0] : 10,
                    useExternalPagination: scope.dynamicPaginationCallback ? true : false,
                    enableCellEditOnFocus: true,
                    enableFiltering: true,
                    enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
                    treeRowHeaderAlwaysVisible: false,
                    showTreeExpandNoChildren: false
                };
                var callback = scope.$eval(scope.callback);
                var cellClassFunction = scope.$parent.$eval(scope.cellClassFunction);
                var cellEditableConditionFunction = scope.$parent.$eval(scope.cellEditableConditionFunction);

                scope.gridConfig = defaultGridOptions;
                var modifiedColDef;

                if (scope.api) {
                    scope.api.getActiveColumns = function () {
                        return scope.gridConfig.columnDefs;
                    };
                }

                scope.$watch('focusRowCol', function (n, o) {
                    if(n){
                        gridInstance.cellNav.scrollToFocus(n.row.entity,n.col.colDef)
                    }
                });

                scope.$watch('scope.dynamicItemTotal', function (n, o) {
                    scope.gridConfig.totalItems = scope.dynamicItemTotal;
                });

                scope.$watch('searchTerm', function (n, o) {
                    if (n && typeof n == 'string') {
                        gridInstance.grid.refresh();
                    }
                });

                scope.$watch('colDef', function (n, o) {
                    angular.isFunction(scope.onRenderingStart) && scope.onRenderingStart();

                    if (scope.$eval(n)) {
                        modifiedColDef = gridConfigProvider.getMassagedGirdConfig(scope.$eval(n), scope, cellClassFunction, cellEditableConditionFunction);
                        _.each(modifiedColDef, function (def, idx, defs) {
                            if (def.customTreeAggregationFinalizerFn) {
                                def.customTreeAggregationFinalizerFn = eval("(" + def.customTreeAggregationFinalizerFn + ")");
                            }
                            if (def.customTreeAggregationFn) {
                                def.customTreeAggregationFn = eval("(" + def.customTreeAggregationFn + ")");
                            }
                        });
                        scope.gridConfig.columnDefs = null;
                        scope.gridConfig.columnDefs = modifiedColDef;

                        var groupingCol = _.filter(scope.gridConfig.columnDefs, function (col) { return col.isGrouped;})
                        if (groupingCol && groupingCol.length > 0 && gridInstance) {
                            gridInstance.grouping.clearGrouping();
                            _.each(groupingCol, function (col) {
                                gridInstance.grouping.groupColumn(col.field);
                            });
                        }
                    }
                });

                scope.$watch('otherGridOptions', function (n, o) {
                    angular.isFunction(scope.onRenderingStart) && scope.onRenderingStart();

                    if (scope.$eval(n)) {
                        var modifiedOtherGridOptions = angular.merge({}, scope.gridConfig, scope.$eval(n));
                        _.each(modifiedOtherGridOptions.appScopeProvider, function (prop, i, props) {
                            modifiedOtherGridOptions.appScopeProvider[i] = eval(prop);
                        });
                        scope.gridConfig = null;
                        scope.gridConfig = modifiedOtherGridOptions;
                    }
                });

                scope.$watch('model', function (newModel) {
                    angular.isFunction(scope.onRenderingStart) && scope.onRenderingStart();

                    if (!newModel) {
                        scope.gridConfig.data = [];
                        return;
                    }
                    var treeColumns = treeViewColumnsToBeCreated(scope.gridConfig.columnDefs);
                    if (treeColumns.length > 0) {
                        scope.gridConfig = angular.extend(scope.gridConfig, {
                            showTreeRowHeader: true,
                            enableRowHeaderSelection: true, // Display checkboxes on every row when it's true
                            showTreeExpandNoChildren: false
                        });
                        scope.gridConfig.data = assignTreeLevel($filter('orderBy')(newModel, treeColumns[0].field), treeColumns[0].field);
                    }
                    else {
                        scope.gridConfig.data = newModel;
                    }
                });


                if (!gridInstance) {
                    scope.gridConfig.onRegisterApi = getGridInstanceCallback;
                }


                /*
                 *  This function will check and return an array of columns for tree view
                 */
                var treeViewColumnsToBeCreated = function (colDefs) {
                    return _.filter(colDefs, function (col) {
                        return col.isTree;
                    });
                };

                /*
                 *  Sort grid data
                 */
                var sortData = function (data, key) {
                    return data.slice(0).sort(function (a, b) {
                        return (eval('a.' + key) > eval('b.' + key)) ? 1 : (eval('a.' + key) < eval('b.' + key)) ? -1 : 0;
                    });
                };

                /*
                 *  Assign tree view since it is required to create a tree view
                 */
                var assignTreeLevel = function (data, key) {
                    var loopedItems = [];
                    for (var i = 0; i < data.length; i++) {
                        data[i].$$treeLevel = 0;
                        if (loopedItems.indexOf(eval('data[i].' + key)) > -1) {
                            data[i].$$treeLevel = 1;
                        }
                        if (eval('data[i].' + key).toString().indexOf('.') > -1) {
                            var SplitLevelArr = eval('data[i].' + key).toString().split('.');
                            data[i].$$treeLevel = SplitLevelArr.length - 1;
                            if (loopedItems.indexOf(eval('data[i].' + key)) > -1) {
                                data[i].$$treeLevel = parseInt(data[i].$$treeLevel) + 1;
                            }
                        }
                        loopedItems.push(eval('data[i].' + key));
                    }
                    return data;
                };

                function getCellValue(row, col) {
                    var data = gridInstance.grid.getCellDisplayValue(row, col);
                    return data ? data.toString() : "";
                };

                function outerSearchCallback(rows, cols) {
                    if (scope.searchTerm && typeof scope.searchTerm == 'string' && scope.searchTerm.length > 0) {
                        _.each(rows, function (row, rowIndex) {
                            var match = false;
                            _.each(cols, function (col) {
                                var cellValue = $filter('translate')(getCellValue(row, col));
                                if (col.colDef.attributes && col.colDef.attributes.type && col.colDef.attributes.type.toLowerCase() == "date") {
                                    var formattedDate = (cellValue).replace(new RegExp("/", "ig"), '');
                                    formattedDate = formattedDate.split('+');
                                    formattedDate = eval('new ' + formattedDate[0] + (formattedDate.length > 1 ? ')' : ''));
                                    var month = formattedDate.getMonth() + 1 + '';
                                    if (month.length === 1) {
                                        month = 0 + '' + month;
                                    }
                                    formattedDate = formattedDate.getDate() + '/' + month + '/' + formattedDate.getFullYear();
                                    var decession = formattedDate.toLowerCase().trim().indexOf(escape(scope.searchTerm).replace(/%5C/g, '').trim()) > -1;
                                    if (decession) {
                                        match = true;
                                    }
                                }
                                else if (cellValue.match(new RegExp(scope.searchTerm, "i"))) {
                                    match = true;
                                }
                            });
                            row.visible = match;
                        });
                    };
                    return rows;
                };

                function onCheckboxSelect(row) {
                    if (angular.isFunction(callback)) {
                        callback('composedGridCheckBoxDispatcher', {
                            "row": row
                        });
                    }
                }

                //  this timeout prevents rows rendered callback being fired multiple times
                var rowsRenderedTimeout;
                function getGridInstanceCallback(instance) {
                    if (angular.isFunction(callback)) {
                        callback('gridInstance', instance);
                    }
                    gridInstance = instance;
                    if (typeof scope.api != undefined && scope.api != null && scope.api.rowSelectionCallback) {
                        scope.gridConfig.isRowSelectable = scope.api.rowSelectionCallback;
                        //gridInstance.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
                    }
                    gridInstance.grid.registerRowsProcessor(outerSearchCallback, 200);
                    gridInstance.core.on.rowsRendered(scope, function (row) {
                        if (rowsRenderedTimeout) {
                            $timeout.cancel(rowsRenderedTimeout);
                            rowsRenderedTimeout = undefined;
                        }
                        rowsRenderedTimeout = $timeout(function () {
                            if (angular.isFunction(callback)) {
                                callback('composedGridRowsRenderedDispatcher', {
                                    "row": row
                                });
                            }
                            setHeightForGrid();
                            angular.isFunction(scope.onRenderingFinish) && scope.onRenderingFinish();
                        }, 500);
                    });


                    gridInstance.selection.on.rowSelectionChanged(scope, onCheckboxSelect);
                    gridInstance.cellNav.on.navigate(scope, function (newRowcol, oldRowCol) {
                        if (newRowcol.col.colDef.isRegFocusCol) {
                            if (angular.isFunction(callback)) {
                                callback('composedGridFocusColumnDispatcher', {
                                    "focusedRowColObj": newRowcol,
                                    "bluredRowColObj": oldRowCol,
                                    "instance": gridInstance
                                });
                            }
                        }
                    });
                    gridInstance.edit.on.afterCellEdit(scope, function (rowEntity, colDef) {
                        //if (colDef.isRegUpdateCol) {
                        if (angular.isFunction(callback)) {
                            callback('composedGridUpdateColumnDispatcher', {
                                "rowModel": rowEntity,
                                "colDef": colDef,
                                "instance": gridInstance
                            });
                        }
                        // }
                    });
                    gridInstance.edit.on.beginCellEdit(scope, function (rowEntity, colDef) {
                        //var focusedCell = gridInstance.cellNav.getFocusedCell();
                        //if (!focusedCell.col.cellClass) {
                        //    gridInstance.cellNav.scrollToFocus(rowEntity, colDef);
                        //}

                        switch (colDef.uiType) {
                            case "dropdown":
                                if (colDef.attributes.serviceObj && colDef.attributes.options.length == 0) {
                                    getDataFolDropDown(colDef, rowEntity)
                                } else {
                                    colDef.attributes.options.map(function (x) { x[colDef.attributes.dataKey] = $filter('translate')(x[colDef.attributes.dataKey]) });
                                    scope.dropDownOptions = colDef.attributes.options;
                                }
                                break;
                        };

                        if (colDef.isRegBeginEditCol) {
                            if (angular.isFunction(callback)) {
                                callback('composedGridBeginEditColumnDispatcher', {
                                    "rowModel": rowEntity,
                                    "colDef": colDef
                                });
                            }
                        }
                    });

                    gridInstance.pagination.on.paginationChanged(scope, function (newPage, pageSize) {
                        //alert(newPage+"");
                        if (angular.isFunction(callback)) {
                            callback('composedGridDynamicPaginationCallback', {
                                "gridConfig": scope.gridConfig,
                                "index": newPage,
                                "pageSize": pageSize
                            });
                        }
                    });
                };

                function setHeightForGrid() {
                    var rowCount = gridInstance.core.getVisibleRows(gridInstance.grid).length;
                    var height;
                    if (rowCount == 0) return;
                    if (scope.gridConfig.rowHeight > 0) {
                        height = ((rowCount + 1) * scope.gridConfig.rowHeight) + 54;
                    } else {
                        height = (rowCount * 35) + 54;
                    }
                    $($('.ui-grid')[0]).css({ 'width': '100%', 'height': height });
                    $($('.ui-grid')[0]).find('ui-grid-header-canvas').css("width", "100%");
                    //gridInstance.core.handleWindowResize();
                };


                //*****************************************************autoSuggest bindings START*********************************************
                scope.autoSuggestOptions = [];
                scope.autoSuggestOnChange = function (e, col, row) {
                    if (angular.isUndefined(e.data) || e.data.length == 0) {
                        return;
                    }
                    callback('composedGridAutoSuggestChange', {
                        "row": row,
                        "col": col,
                        "val": (e.data[0] !== undefined ? e.data[0].value : e.displayModel)
                    });
                    //logic to clear split entities autosuggest at grid level, needs to be handled further to make common for other autosuggests
                 
                    if (e.data[0].value == "")   {
                        var obj = row.entity[col.colDef.field.split(".")[0]];
                        var index;
                        if (obj != null && obj != undefined && col.colDef.field.indexOf('split') >= 0) {
                            if (row.entity.id > 0)
                                index = _.findIndex(scope.model, { id: row.entity.id });
                            else {
                                _.each(scope.model, function (data, indexFound) {
                                    if (_.isEqual(data, row.entity)) {
                                        index = indexFound;
                                        return;
                                    }
                                });
                            }
                            scope.model[index][col.colDef.field.split(".")[0]] = {
                                "entityType": obj.entityType, "fieldId": obj.fieldId, "splitEntityId": obj.splitEntityId, "code": 0, "entityCode": null, "name": null, "title": null
                            };
                        }
                    }

                    var serviceObj = col.colDef.attributes.serviceObj;
                    if (serviceObj != undefined) {
                        var req = {
                            type: serviceObj.method === "POST" ?"POST": "GET",
                            url: serviceObj.url,
                            params: JSON.parse(JSON.stringify(serviceObj.param).replace("@term", e.data[0].value)),
                            timeout: 120000,
                            headers: {
                                "Content-Type": "application/json",
                                "UserExecutionContext": JSON.stringify(APPCONSTANTS.userPreferences.UserBasicDetails)
                            }
                        };
                        if (req.type === "POST")
                        {
                            req.data = JSON.parse(JSON.stringify(serviceObj.param).replace("@term", e.data[0].value));
                            delete req.params;
                        }
                        httpService.directhttp(req).then(function (response) {
                            if (serviceObj.CallbackObj) {
                                response = serviceObj.CallbackObj(response, col.colDef.name)
                            }
                            var resp = [];
                            if (typeof response === "string")
                                response = JSON.parse(response);
                            if (serviceObj.isFlatArray) {
                                _.each(response, function (x, index) {
                                    var obj = {};
                                    obj["name"] = x;
                                    obj["code"] = x;
                                    resp.push(obj);
                                });
                            }
                            else {
                                _.each(response, function (obj) {
                                    var mapperObj = {};
                                    _.each(serviceObj.mapper, function (mapper) {
                                        var mapperstri = '';
                                        if (angular.isArray(mapper['toBeMapped'])) {
                                            _.each(mapper['toBeMapped'], function (res) {
                                                mapperstri += obj[res] + " ";
                                            });
                                            mapperstri.trim();
                                        }
                                        else
                                            mapperstri = obj[mapper['toBeMapped']];

                                        mapperObj[mapper['key']] = mapperstri;

                                    });
                                    _.each(serviceObj.staticValues, function (item) {
                                        mapperObj[item['key']] = item['value'];
                                    });
                                    resp.push(mapperObj);
                                });
                            }
                            scope.autoSuggestOptions = resp;

                            //for item number and item description autosuggest
                            if (serviceObj.responseRequired) {
                                callback('composedGridParseItemMasterData', {
                                    "rowModel": row,
                                    "colDef": col,
                                    "response": response,
                                    "value": e.data[0].value
                                });
                            }
                        }, function () {   /* Failure case here */ });
                    }
                    else {
                        return;
                    }

                };
                scope.autoSuggestOnSelect = function (event, autoSuggestModel, row, col) {
                    autoSuggestModel = event.data;
                    callback('composedGridSelectItemMasterData', {
                        "data": autoSuggestModel,
                        "row": row,
                        "col": col,
                        "isModified":true
                    });
                };
                //*****************************************************autoSuggest bindings END***********************************************

                //*****************************************************dropDOwn bindings START***********************************************
                scope.isObject = function (val) {
                    return typeof val == 'object';
                }

                scope.dropDownOnChange = function (row, col, val) {
                    if (angular.isFunction(callback)) {
                        callback('composedGridDropDownOnSelectDispatcher', {
                            "row": row,
                            "col": col,
                            "val": val
                        });
                    }
                };

                scope.dropDownOptions = [];
                function getDataFolDropDown(col, row) {
                    var serviceObj = col.attributes.serviceObj;
                    var req = {
                        method: "GET",
                        url: serviceObj.url,
                        params: serviceObj.param,
                        headers: {
                            "Content-Type": "application/json",
                            "UserExecutionContext": JSON.stringify(APPCONSTANTS.userPreferences.UserBasicDetails)
                        }
                    };
                    httpService.directhttp(req).then(function (response) {
                        if (typeof row[col.field] != 'object') {
                            var resp = [];
                            _.each(response, function (x, index) {
                                var obj = {};
                                obj[col.attributes.dataKey] = $filter('translate')(x);
                                obj[col.attributes.idKey] = index;
                                resp.push(obj);
                            });
                            col.attributes.options = resp;
                        } else {
                            col.attributes.options = response;
                        }
                        scope.dropDownOptions = col.attributes.options;
                    }, function () {
                    });
                };
                //*****************************************************dropDOwn bindings END***********************************************
                //*****************************************************popup bindings START***********************************************


                scope.popUpButtonClickCallback = function (row, col) {
                    // segregate the splitpopup callback function based on config.js 
                    if (angular.isFunction(callback)) {
                        if (col.colDef.isChargesGrid) {
                            callback('composedChargesGridPopupButtonClickDispatcher', {
                                "row": row,
                                "col": col
                            });
                        }
                        else {
                            callback('composedGridPopupButtonClickDispatcher', {
                                "row": row,
                                "col": col
                            });
                        }
                    }

                };

                //*****************************************************popup bindings END***********************************************

                //*****************************************************checkBox bindings START***********************************************
                scope.checkBoxOnChange = function (row, col, val) {
                    callback('composedGridCheckBoxOnChangeDispatcher', {
                        "row": row,
                        "col": col,
                        "val": val
                    });
                };
                //*****************************************************checkBox bindings END***********************************************

                //*****************************************************text & number keyup bindings START***********************************************
                scope.textOrNumberKeyUp = function (e, col, row) {
                    callback('composedGridTextKeyUp', {
                        "row": row,
                        "col": col,
                        "val": e.target.value
                    });
                }
                //*****************************************************text & number keyup bindings END***********************************************

            },
            templateUrl: 'shared/directives/uiElements/smartUiGrid/smartUiGrid.html'
        };
    }]);
})();
